'use client';

import { Alert, AlertBody, Heading, LayoutLinelengthContainer, TextPassage } from '@petsmart-ui/sparky';

import type { ErrorMessageType } from './error.types';

type ErrorMessageProps = Readonly<{
    errorType: ErrorMessageType;
}>;

const errorMessages = {
    estimationValidation: {
        title: 'Not available in your area',
        description: 'Please select another fulfillment method',
    },
    emptyFields: {
        title: 'Information missing',
        description: 'Please review errors for missing information',
    },
    invalidFields: {
        title: 'Invalid entry',
        description: 'Please review the errors below',
    },
    apiError: {
        title: 'Something went wrong',
        description: "We couldn't verify your address. Please try again",
    },
};

export const ErrorMessage = ({ errorType }: ErrorMessageProps) => {
    const { title, description } = errorMessages[errorType];

    return (
        <Alert variant="error" iconName="exclamation-circle-fill">
            <AlertBody>
                <LayoutLinelengthContainer>
                    <Heading size="body-bold" tagName="h2">
                        {title}
                    </Heading>
                </LayoutLinelengthContainer>
                <TextPassage>{description}</TextPassage>
            </AlertBody>
        </Alert>
    );
};
